'use client';

import {styled} from "@mui/system";
import {Typography} from "@mui/material";

const DescriptionMetrics = styled(Typography)(({theme}) => ({
    marginBottom: '14px',
    color: theme.palette.custom?.darkGray
}));

export default DescriptionMetrics;
